import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import LoyaltyLandingPageTierInformation from 'loyalty/components/LoyaltyLandingPageTierInformation'
import { rem } from 'polished'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Section = styled(Pane)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }
`

function LoyaltyLandingPageDiscoverTiersSection() {
  const intl = useIntl()

  const headingText = intl.formatMessage({
    id: 'uEdvZ_NxUQRl36U_sxfO',
    defaultMessage: 'Discover a world of rewards, one tier at a time',
    description: 'Section heading for the loyalty tier discovery section',
  })
  const bodyText = intl.formatMessage({
    id: '6YppS8FjUdMcYGRmxS7T',
    defaultMessage: 'Unlock bigger and better travel benefits as you move from Bronze to Platinum.',
    description: 'Description encouraging users to progress through loyalty tiers',
  })

  return <Section paletteType="inverse">
    <LayoutContainer variant="medium">
      <Group direction="vertical" gap={72}>
        <VerticalSpacer gap={32}>
          <VerticalSpacer gap={8}>
            <Heading variant="heading2" align="center">
              {headingText}
            </Heading>
            <BodyText variant="large" align="center">
              {bodyText}
            </BodyText>
          </VerticalSpacer>
          <LoyaltyLandingPageTierInformation />
        </VerticalSpacer>
      </Group>
    </LayoutContainer>
  </Section>
}

export default LoyaltyLandingPageDiscoverTiersSection
